import styled, { css } from 'styled-components';
import { zIndex } from '@styles/zIndex.styles';
import { createEmptyArray } from '@utils/createEmptyArray';
import { device } from '@styles/tools/breakpoints.styles';

export const NAV_SIDEBAR_WIDTH = 64;

const NAV_LINK_HEIGHT = 70;
const NAV_LINK_MOBILE_HEIGHT = 55;

export const Line = styled.div`
  position: absolute;
  top: 0;
  transition: 0.3s transform cubic-bezier(0.17, 0.67, 0.25, 1);
`;

export const Nav = styled.div`
  position: relative;
  width: 100%;
`;

const generateLineTransforms = count =>
  createEmptyArray(count).map(
    (_, index) => css`
      a:nth-child(${index + 1}).active ~ ${Line} {
        transform: translateY(${NAV_LINK_HEIGHT * index + 1}px);
        ${device.mobile} {
          transform: translateY(${NAV_LINK_MOBILE_HEIGHT * index + 1}px);
        }
      }
    `,
  );

export const Container = styled.div`
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: ${zIndex.sidebar};
  background-color: ${props => props.theme.colors.purple700};
  display: flex;
  align-items: center;
  transform: ${props => (props.active ? 'translateX(0);' : 'translateX(-105%);')};
  transition: transform ease-in-out 0.3s;
  box-shadow: 0 1px 4px ${props => props.theme.colors.grey700};

  ${device.desktop} {
    width: ${NAV_SIDEBAR_WIDTH}px;
    box-shadow: unset;
  }

  ${device.desktop} {
    transform: translateX(0);
  }

  ${Line} {
    width: 4px;
    margin: 13px 0;
    height: ${NAV_LINK_HEIGHT - 30}px;
    right: 0;
    background-color: ${props => props.theme.colors.white};
    border-radius: ${props => props.theme.forms.borderRadius * 4}px 0px 0px ${props => props.theme.forms.borderRadius * 4}px;

    ${device.mobile} {
      height: ${NAV_LINK_MOBILE_HEIGHT - 20}px;
      margin: ${props => props.theme.global.gutterSpace * 0.625}px 0;
    }
  }

  .tooltip-nav-bar {
    width: 90%;
  }

  a {
    width: 100%;
    display: block;
    padding: 0 ${props => props.theme.global.gutterSpace}px;

    ${device.desktop} {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    svg {
      fill: ${props => props.theme.colors.white};
      opacity: 0.5;
    }
    &:hover svg,
    &.active svg {
      opacity: 1;
    }
  }

  ${props => generateLineTransforms(props.count)}
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${NAV_LINK_HEIGHT}px;

  ${device.mobile} {
    height: ${NAV_LINK_MOBILE_HEIGHT}px;
  }

  ${device.desktop} {
    justify-content: center;
  }
`;

export const MobileRouteName = styled.h5`
  margin: 0;
  color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSizes[2]};
  margin-left: ${props => props.theme.global.gutterSpace * 0.25}px;
  opacity: 0.5;
  font-weight: 500;
  white-space: nowrap;

  .active & {
    opacity: 1;
  }

  ${device.desktop} {
    display: none;
  }
`;
